import React, { Fragment, useState, useEffect } from "react";
import man from "../../../assets/images/dashboard/user.png";
import { User, Mail, Lock, Settings, LogOut } from "react-feather";
import { firebase_app } from "../../../data/config";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";
import { EditProfile, Inbox, LockScreen } from "../../../constant";

const UserMenu = ({ history }) => {
  const [profile, setProfile] = useState("");
  // auth0 profile
  const { logout } = useAuth0();
  // const authenticated = JSON.parse(localStorage.getItem("authenticated"));
  const authenticated = JSON.parse(sessionStorage.getItem("authenticated"));
  // const auth0_profile = JSON.parse(localStorage.getItem("auth0_profile"));
  const auth0_profile = JSON.parse(sessionStorage.getItem("auth0_profile"));

  useEffect(() => {
    // setProfile(localStorage.getItem("profileURL") || man);
    setProfile(sessionStorage.getItem("profileURL") || man);
  }, []);

  const Logout_From_Firebase = () => {
    // localStorage.removeItem("profileURL");
    sessionStorage.removeItem("profileURL");
    // localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    // firebase_app.auth().signOut()
    history.push(`${process.env.PUBLIC_URL}/login`);
  };
  const handleLogout = () => {
    sessionStorage.clear();
    history.push(`${process.env.PUBLIC_URL}/login`);
  };

  const Logout_From_Auth0 = () => {
    // localStorage.removeItem("auth0_profile");
    sessionStorage.removeItem("auth0_profile");
    // localStorage.setItem("authenticated", false);
    sessionStorage.setItem("authenticated", false);
    history.push(`${process.env.PUBLIC_URL}/login`);
    logout();
  };

  return (
    <Fragment>
      <li className="onhover-dropdown">
        <div className="media align-items-center">
          <img
            className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded"
            src={authenticated ? auth0_profile.picture : profile}
            alt="header-user"
          />
          <div className="dotted-animation">
            <span className="animate-circle"></span>
            <span className="main-circle"></span>
          </div>
        </div>
        <ul className="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
          <li>
            <a href="#">{sessionStorage.getItem("role")?.toUpperCase()}</a>
          </li>
          <li>
            <a href="#">{sessionStorage.getItem("name")?.toUpperCase()}</a>
          </li>
          <li>
            <a href="#">{sessionStorage.getItem("email")?.toUpperCase()}</a>
          </li>
          <li>
            <a
              // onClick={authenticated ? Logout_From_Auth0 : Logout_From_Firebase}
              onClick={handleLogout}
              //   href="#javascript"
            >
              <LogOut /> {"Log out"}
            </a>
          </li>
        </ul>
      </li>
    </Fragment>
  );
};

export default withRouter(UserMenu);
